import { render, staticRenderFns } from "./certification.vue?vue&type=template&id=807a1452&scoped=true"
var script = {}
import style0 from "./certification.vue?vue&type=style&index=0&id=807a1452&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807a1452",
  null
  
)

export default component.exports